[
  {
    "id": "Slimes",
    "name": "Slime",
    "killTarget": 1000,
    "monsters": ["Green Slime", "Frost Jelly", "Big Slime", "Tiger Slime", "Prismatic Slime"],
    "reward": {
      "name": "Slime Charmer Ring",
      "itemId": "(O)520",
      "image": "images/rings/Slime Charmer Ring.png"
    }
  },
  {
    "id": "Shadows",
    "name": "Void Spirits",
    "killTarget": 150,
    "monsters": ["Shadow Shaman", "Shadow Brute", "Shadow Sniper"],
    "reward": {
      "name": "Savage Ring",
      "itemId": "(O)523",
      "image": "images/rings/Savage Ring.png"
    }
  },
  {
    "id": "Bats",
    "name": "Bats",
    "killTarget": 200,
    "monsters": ["Bat", "Frost Bat", "Lava Bat", "Iridium Bat"],
    "reward": {
      "name": "Vampire Ring",
      "itemId": "(O)522",
      "image": "images/rings/Vampire Ring.png"
    }
  },
  {
    "id": "Skeletons",
    "name": "Skeletons",
    "killTarget": 50,
    "monsters": ["Skeleton", "Skeleton Mage"],
    "reward": {
      "name": "Skeleton Mask",
      "itemId": "(H)8",
      "image": "images/hats/Skeleton Mask.png"
    }
  },
  {
    "id": "Insects",
    "name": "Cave Insects",
    "killTarget": 80,
    "monsters": ["Grub", "Cave Fly", "Bug"],
    "reward": {
      "name": "Insect Head",
      "itemId": "(W)13",
      "image": "images/weapons/swords/Insect Head.png"
    }
  },
  {
    "id": "Duggy",
    "name": "Duggies",
    "killTarget": 30,
    "monsters": ["Duggy", "Magma Duggy"],
    "reward": {
      "name": "Hard Hat",
      "itemId": "(H)27",
      "image": "images/hats/Hard Hat.png"
    }
  },
  {
    "id": "DustSpirits",
    "name": "Dust Sprites",
    "killTarget": 500,
    "monsters": ["Dust Spirit"],
    "reward": {
      "name": "Burglar's Ring",
      "itemId": "(O)526",
      "image": "images/rings/Burglar's Ring.png"
    }
  },
  {
    "id": "Crabs",
    "name": "Rock Crabs",
    "killTarget": 60,
    "monsters": ["Rock Crab", "Lava Crab", "Iridium Crab"],
    "reward": {
      "name": "Crabshell Ring",
      "itemId": "(O)810",
      "image": "images/rings/Crabshell Ring.png"
    }
  },
  {
    "id": "Mummies",
    "name": "Mummies",
    "killTarget": 100,
    "monsters": ["Mummy"],
    "reward": {
      "name": "Arcane Hat",
      "itemId": "(H)60",
      "image": "images/hats/Arcane Hat.png"
    }
  },
  {
    "id": "Dinos",
    "name": "Pepper Rex",
    "killTarget": 50,
    "monsters": ["Pepper Rex"],
    "reward": {
      "name": "Knight's Helmet",
      "itemId": "(H)50",
      "image": "images/hats/Knight's Helmet.png"
    }
  },
  {
    "id": "Serpents",
    "name": "Serpents",
    "killTarget": 250,
    "monsters": ["Serpent", "Royal Serpent"],
    "reward": {
      "name": "Napalm Ring",
      "itemId": "(O)811",
      "image": "images/rings/Napalm Ring.png"
    }
  },
  {
    "id": "FlameSpirits",
    "name": "Magma Sprites",
    "killTarget": 150,
    "monsters": ["Magma Sprite", "Magma Sparker"],
    "reward": {
      "name": "Marlon's Phone Number",
      "itemId": null,
      "image": null
    }
  }
]
